module.exports = __webpack_public_path__ + "img/vertical_6_3_7005.c150545c.png";